import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import RequestOrderService from "services/RequestOrderService";
import Utils from "utils";
import openNotification from "utils/notification";

export const getRequestOrderApi = createAsyncThunk(
  "requestOrder/getRequestOrderApi",
  async (data, { rejectWithValue }) => {
    try {
      const response = await RequestOrderService.getRequestOrder(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const getRequestOrderDetailApi = createAsyncThunk(
  "requestOrder/getRequestOrderDetailApi",
  async (id, { rejectWithValue }) => {
    try {
      const response = await RequestOrderService.getRequestOrderDetail(id);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const getTransferSourceStoresApi = createAsyncThunk(
  "requestOrder/getTransferSourceStoresApi",
  async (_, { rejectWithValue }) => {
    try {
      const response = await RequestOrderService.getTransferSourceStores();
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const addRequestOrderApi = createAsyncThunk(
  "requestOrder/addRequestOrderApi",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;

      const response = await RequestOrderService.createRequestOrder(payload);

      if (onSuccess) onSuccess(response);

      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );

      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const updateRequestOrderApi = createAsyncThunk(
  "requestOrder/updateRequestOrderApi",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;

      const response = await RequestOrderService.updateRequestOrder(payload);

      if (onSuccess) onSuccess(response);

      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );

      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const updatePendingRequestOrderItemsApi = createAsyncThunk(
  "requestOrder/updatePendingRequestOrderItemsApi",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, ...payload } = data;

      const response =
        await RequestOrderService.updatePendingRequestOrderItems(payload);

      if (onSuccess) onSuccess(response);

      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );

      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const submitRequestOrderApi = createAsyncThunk(
  "requestOrder/submitRequestOrderApi",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, id } = data;

      const response = await RequestOrderService.submitRequestOrder(id);

      if (onSuccess) onSuccess(response);

      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );

      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const approveBranchRequestOrderApi = createAsyncThunk(
  "requestOrder/approveBranchRequestOrderApi",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, id } = data;

      const response = await RequestOrderService.approveBranchRequestOrder(id);

      if (onSuccess) onSuccess(response);

      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );

      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const rejectBranchRequestOrderApi = createAsyncThunk(
  "requestOrder/rejectBranchRequestOrderApi",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;

      const response =
        await RequestOrderService.rejectBranchRequestOrder(payload);

      if (onSuccess) onSuccess(response);

      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );

      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const approvePurchasingRequestOrderApi = createAsyncThunk(
  "requestOrder/approvePurchasingRequestOrderApi",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, id } = data;

      const response =
        await RequestOrderService.approvePurchasingRequestOrder(id);

      if (onSuccess) onSuccess(response);

      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );

      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const rejectPurchasingRequestOrderApi = createAsyncThunk(
  "requestOrder/rejectPurchasingRequestOrderApi",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;

      const response =
        await RequestOrderService.rejectPurchasingRequestOrder(payload);

      if (onSuccess) onSuccess(response);

      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );

      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const delRequestOrderApi = createAsyncThunk(
  "requestOrder/delRequestOrderApi",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, id } = data;

      const response = await RequestOrderService.delRequestOrder(id);

      if (onSuccess) onSuccess(response);

      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );

      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const cancelRequestOrderApi = createAsyncThunk(
  "requestOrder/cancelRequestOrderApi",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, ...payload } = data;

      const response = await RequestOrderService.cancelRequestOrder(payload);

      if (onSuccess) onSuccess(response);

      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );

      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const resyncRequestOrderStatusApi = createAsyncThunk(
  "requestOrder/resyncRequestOrderStatusApi",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, id } = data;

      const response = await RequestOrderService.resyncStatus(id);

      if (onSuccess) onSuccess(response);

      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );

      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const resolveTransferItemsApi = createAsyncThunk(
  "requestOrder/resolveTransferItemsApi",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, ...payload } = data;

      const response = await RequestOrderService.resolveTransferItems(payload);

      if (onSuccess) onSuccess(response);

      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const getMenuBadgesApi = createAsyncThunk(
  "requestOrder/getMenuBadges",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await RequestOrderService.getMenuBadges(payload);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const exportRequestOrderExcel = createAsyncThunk(
  "requestOrder/exportExcel",
  async (params, { rejectWithValue }) => {
    try {
      const blob = await RequestOrderService.exportExcel(params);
      const url = window.URL.createObjectURL(blob);
      const filename = `Danh sách yêu cầu mua hàng.xlsx`;

      const link = document.createElement("a");
      link.href = url;
      link.download = filename;

      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);

      return true;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

const initialState = {
  loading: false,
  loadingExport: false,

  transferSourceStoresLoading: false,
  resolveTransferItemsLoading: false,
  updatePendingItemsLoading: false,
  cancelLoading: false,

  requestOrderList: [],
  requestOrderDetail: {},
  transferSourceStores: [],
  resolvedTransferItems: [],
  resolvedTransferHasMissing: false,

  totalCount: 0,

  currentRequestId: undefined,

  menuBadges: {},
};

export const requestOrderSlice = createSlice({
  name: "requestOrder",
  initialState,
  reducers: {
    showLoading: (state) => {
      state.loading = true;
    },
    setRequestOrderDetail: (state, action) => {
      state.requestOrderDetail = action.payload || {};
    },
    clearResolvedTransferItems: (state) => {
      state.resolvedTransferItems = [];
      state.resolvedTransferHasMissing = false;
      state.resolveTransferItemsLoading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getRequestOrderApi.pending, (state, action) => {
        state.loading = true;
        state.currentRequestId = action.meta.requestId;
      })
      .addCase(getRequestOrderApi.fulfilled, (state, action) => {
        state.loading = false;
        state.requestOrderList = action.payload.data;
        state.totalCount = action.payload.totalCount;
      })
      .addCase(getRequestOrderApi.rejected, (state) => {
        state.loading = false;
      })

      .addCase(getRequestOrderDetailApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(getRequestOrderDetailApi.fulfilled, (state, action) => {
        state.loading = false;
        state.requestOrderDetail = action.payload;
      })
      .addCase(getRequestOrderDetailApi.rejected, (state) => {
        state.loading = false;
      })

      .addCase(getTransferSourceStoresApi.pending, (state) => {
        state.transferSourceStoresLoading = true;
      })
      .addCase(getTransferSourceStoresApi.fulfilled, (state, action) => {
        state.transferSourceStoresLoading = false;
        state.transferSourceStores = action.payload?.data || [];
      })
      .addCase(getTransferSourceStoresApi.rejected, (state) => {
        state.transferSourceStoresLoading = false;
        state.transferSourceStores = [];
      })

      .addCase(resolveTransferItemsApi.pending, (state) => {
        state.resolveTransferItemsLoading = true;
      })
      .addCase(resolveTransferItemsApi.fulfilled, (state, action) => {
        state.resolveTransferItemsLoading = false;
        state.resolvedTransferItems = action.payload?.items || [];
        state.resolvedTransferHasMissing =
          action.payload?.hasMissingItems || false;
      })
      .addCase(resolveTransferItemsApi.rejected, (state) => {
        state.resolveTransferItemsLoading = false;
        state.resolvedTransferItems = [];
        state.resolvedTransferHasMissing = false;
      })

      .addCase(addRequestOrderApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(addRequestOrderApi.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(addRequestOrderApi.rejected, (state) => {
        state.loading = false;
      })

      .addCase(updateRequestOrderApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateRequestOrderApi.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(updateRequestOrderApi.rejected, (state) => {
        state.loading = false;
      })

      .addCase(updatePendingRequestOrderItemsApi.pending, (state) => {
        state.updatePendingItemsLoading = true;
      })
      .addCase(updatePendingRequestOrderItemsApi.fulfilled, (state) => {
        state.updatePendingItemsLoading = false;
      })
      .addCase(updatePendingRequestOrderItemsApi.rejected, (state) => {
        state.updatePendingItemsLoading = false;
      })

      .addCase(submitRequestOrderApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(submitRequestOrderApi.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(submitRequestOrderApi.rejected, (state) => {
        state.loading = false;
      })

      .addCase(approveBranchRequestOrderApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(approveBranchRequestOrderApi.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(approveBranchRequestOrderApi.rejected, (state) => {
        state.loading = false;
      })

      .addCase(rejectBranchRequestOrderApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(rejectBranchRequestOrderApi.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(rejectBranchRequestOrderApi.rejected, (state) => {
        state.loading = false;
      })

      .addCase(approvePurchasingRequestOrderApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(approvePurchasingRequestOrderApi.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(approvePurchasingRequestOrderApi.rejected, (state) => {
        state.loading = false;
      })

      .addCase(rejectPurchasingRequestOrderApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(rejectPurchasingRequestOrderApi.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(rejectPurchasingRequestOrderApi.rejected, (state) => {
        state.loading = false;
      })

      .addCase(delRequestOrderApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(delRequestOrderApi.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(delRequestOrderApi.rejected, (state) => {
        state.loading = false;
      })

      .addCase(cancelRequestOrderApi.pending, (state) => {
        state.cancelLoading = true;
      })
      .addCase(cancelRequestOrderApi.fulfilled, (state) => {
        state.cancelLoading = false;
      })
      .addCase(cancelRequestOrderApi.rejected, (state) => {
        state.cancelLoading = false;
      })

      .addCase(resyncRequestOrderStatusApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(resyncRequestOrderStatusApi.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(resyncRequestOrderStatusApi.rejected, (state) => {
        state.loading = false;
      })

      .addCase(getMenuBadgesApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(getMenuBadgesApi.fulfilled, (state, action) => {
        state.loading = false;
        state.menuBadges = action.payload;
      })
      .addCase(getMenuBadgesApi.rejected, (state) => {
        state.loading = false;
      })
      .addCase(exportRequestOrderExcel.pending, (state) => {
        state.loadingExport = true;
      })
      .addCase(exportRequestOrderExcel.fulfilled, (state) => {
        state.loadingExport = false;
      })
      .addCase(exportRequestOrderExcel.rejected, (state) => {
        state.loadingExport = false;
      });
  },
});

export const {
  showLoading,
  setRequestOrderDetail,
  clearResolvedTransferItems,
} = requestOrderSlice.actions;

export default requestOrderSlice.reducer;
